export enum I18nResource {
  TH_TH = 'th-TH',
  EN_US = 'en-US',
  JA_JP = 'ja-JP',
  KO_KR = 'ko-KR',
  TR_TR = 'tr-TR',
  HI_IN = 'hi-IN',
}

export type I18nResourceValue = (typeof I18nResource)[keyof typeof I18nResource];
